export const VUEX_CHANGE_COVER_ROOT = {
  GETTERS: {
    getReferenceData: 'getReferenceData',
    getMemberDetails: 'getMemberDetails',
    getMembershipPolicy: 'getMembershipPolicy',
    getMemberPolicies: 'getMemberPolicies',
    getEligibilityDetails: 'getEligibilityDetails',
    getMembershipProducts: 'getMembershipProducts',
    getCurrentComposition: 'getCurrentComposition',
    getCurrentRebateTier: 'getCurrentRebateTier',
    getCurrentMyCircumstances: 'getCurrentMyCircumstances',
    getCurrentExcess: 'getCurrentExcess',
    getCurrentChildren: 'getCurrentChildren',
    getCurrentState: 'getCurrentState',
    getCurrentEligibility: 'getCurrentEligibility',
    getCurrentPremium: 'getCurrentPremium',
    getCurrentCoverStartDate: 'getCurrentCoverStartDate',
    getSubmitPolicyInProcess: 'getSubmitPolicyInProcess',
  },
  MUTATIONS: {
    updateReferenceData: 'updateReferenceData',
    updateMemberDetails: 'updateMemberDetails',
    updateMembershipProducts: 'updateMembershipProducts',
    updateMembershipPolicy: 'updateMembershipPolicy',
    updateMemberPolicies: 'updateMemberPolicies',
    updateEligibilityDetails: 'updateEligibilityDetails',
    updateCurrentComposition: 'updateCurrentComposition',
    updateCurrentRebateTier: 'updateCurrentRebateTier',
    updateCurrentMyCircumstances: 'updateCurrentMyCircumstances',
    updateCurrentExcess: 'updateCurrentExcess',
    updateCurrentChildren: 'updateCurrentChildren',
    updateCurrentState: 'updateCurrentState',
    updateCurrentEligibility: 'updateCurrentEligibility',
    updateCurrentPremium: 'updateCurrentPremium',
    updateCurrentCoverStartDate: 'updateCurrentCoverStartDate',
    resetData: 'resetData',
    updateSubmitPolicyInProcess: 'updateSubmitPolicyInProcess',
  },
};

export const VUEX_CHANGE_PRODUCT = {
  GETTERS: {
    getChangeCover: 'getChangeCover',
    getMyDetails: 'getMyDetails',
    getMyCover: 'getMyCover',
    getMyNeeds: 'getMyNeeds',
    getClosedHospitalProduct: 'getClosedHospitalProduct',
    getClosedExtrasProduct: 'getClosedExtrasProduct',
    getRecommendedProducts: 'getRecommendedProducts',
    getPaymentFrequency: 'getPaymentFrequency',
    getSelectedProducts: 'getSelectedProducts',
    getSelectedExcess: 'getSelectedExcess',
    getIsFromEmailQuote: 'getIsFromEmailQuote',
    getPolicyHolderProductHistory: 'getPolicyHolderProductHistory',
    getPartnerProductHistory: 'getPartnerProductHistory',
  },
  MUTATIONS: {
    updateMyDetails: 'updateMyDetails',
    updateMyCover: 'updateMyCover',
    updateMyNeeds: 'updateMyNeeds',
    updateClosedHospitalProduct: 'updateClosedHospitalProduct',
    updateClosedExtrasProduct: 'updateClosedExtrasProduct',
    updateRecommendedProducts: 'updateRecommendedProducts',
    updatePaymentFrequency: 'updatePaymentFrequency',
    resetMyNeeds: 'resetMyNeeds',
    updateSelectedProducts: 'updateSelectedProducts',
    updateSelectedExcess: 'updateSelectedExcess',
    updatePolicyHolderProductHistory: 'updatePolicyHolderProductHistory',
    updatePartnerProductHistory: 'updatePartnerProductHistory',
    resetChangeCoverData: 'resetChangeCoverData',
    updateIsFromEmailQuote: 'updateIsFromEmailQuote',
  },
};

export const VUEX_CAPTURE_ADDITIONAL_INFORMATION = {
  GETTERS: {
    getCaptureInformationReferenceData: 'getCaptureInformationReferenceData',
    getPolicyChangesInformation: 'getPolicyChangesInformation',
    getPolicyHolderInformation: 'getPolicyHolderInformation',
    getPartnerInformation: 'getPartnerInformation',
    getChildrenInformation: 'getChildrenInformation',
    getEligibilityInformation: 'getEligibilityInformation',
    getRebateInformation: 'getRebateInformation',
    getConfirmation: 'getConfirmation',
    getCaptureAdditionalInformationData: 'getCaptureAdditionalInformationData',
    getInitialPolicyHolderLhc: 'getInitialPolicyHolderLhc',
    getInitialPolicyHolderAbd: 'getInitialPolicyHolderAbd',
    getInitialPartnerLhc: 'getInitialPartnerLhc',
    getInitialPartnerAbd: 'getInitialPartnerAbd',
    getInitialPolicyHolderPortalAbd: 'getInitialPolicyHolderPortalAbd',
    getInitialPartnerPortalAbd: 'getInitialPartnerPortalAbd',
    getInitialData: 'getInitialData',
  },
  MUTATIONS: {
    updateCaptureInformationReferenceData: 'updateCaptureInformationReferenceData',
    updatePolicyChanges: 'updatePolicyChanges',
    updatePolicyHolder: 'updatePolicyHolder',
    updatePartner: 'updatePartner',
    updateChildren: 'updateChildren',
    updateEligibility: 'updateEligibility',
    updateRebate: 'updateRebate',
    updateConfirmation: 'updateConfirmation',
    updateInitialData: 'updateInitialData',
    updateEligibilityInitialData: 'updateEligibilityInitialData',
    updateInitialPolicyHolderLhc: 'updateInitialPolicyHolderLhc',
    updateInitialPolicyHolderAbd: 'updateInitialPolicyHolderAbd',
    updateInitialPartnerLhc: 'updateInitialPartnerLhc',
    updateInitialPartnerAbd: 'updateInitialPartnerAbd',
    updateInitialPolicyHolderPortalAbd: 'updateInitialPolicyHolderPortalAbd',
    updateInitialPartnerPortalAbd: 'updateInitialPartnerPortalAbd',
    updateInitialPolicyHolderVeteranCard: 'updateInitialPolicyHolderVeteranCard',
    updateInitialPartnerVeteranCard: 'updateInitialPartnerVeteranCard',
    resetCAIData: 'resetCAIData',
  },
};
